'use client'

import React, { useState } from 'react'
import { redirect } from 'next/navigation'
import Link from 'next/link'
import FormAuth from '@/entities/FormAuth'
import SocialAuth from '@/entities/SocialAuth'
import { useInView } from 'react-intersection-observer'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser.js'

// import { Helmet } from 'react-helmet'

import { TOAST_ERROR, TOAST_SUCCESS } from '@/shared/constants/toastTypes.js'
import {
    useCheckUserMutation,
    useSignInMutation,
} from '@/shared/api-rtk/index.js'
import { useGetCountProductsQuery } from '@/shared/api-rtk/api-list/cartApi'

export const LoginPage = () => {
    const { ref, inView } = useInView({
        threshold: 0,
        triggerOnce: true,
    })
    const { userAuth: isAuth, setUser, userInfo } = useGetIsAuthUser()
    const { refetch: refetchCountCart } = useGetCountProductsQuery()
    const [signIn] = useSignInMutation()
    const [checkAuth] = useCheckUserMutation()

    //check auth
    const navigate = (path) => redirect(path)
    React.useEffect(() => {
        console.log(isAuth)
        if (isAuth) {
            navigate('/my-account')
        }
    }, [isAuth])

    const signInProfile = (e, rememberDevice) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        const formProps = Object.fromEntries(formData)

        if (formProps) {
            signIn(formProps)
                .unwrap()
                .then((res) => {
                    if (!res.data) {
                        TOAST_ERROR(res.error)
                        //TOAST_ERROR('Неверный логин или пароль')
                        return
                    }
                    if (res.result === 'success') {
                        TOAST_SUCCESS('Вы успешно авторизовались!')
                        //Назначаем пользователя при успешной авторизации в стейт
                        setUser(res.data)
                        refetchCountCart()
                    }
                })
                .catch((err) => {
                    TOAST_ERROR('Ошибка авторизации, попробуйте позже')
                })
        }
    }

    return (
        <div
            ref={ref}
            className={`LoginPage ${
                inView && 'animate__animated animate__slideInLeft'
            }`}
        >
            {/* <Helmet>
                <title>Авторизация</title>
            </Helmet> */}
            <h1>Вход</h1>
            <div className={'form-container'}>
                <FormAuth textButton={'Войти'} submitForm={signInProfile} />
                <SocialAuth />
                <span className={'redirect'}>
                    Нет аккаунта? Косметолог или салон красоты?{' '}
                    <Link href={'/create-account'}>Зарегистрироваться</Link>
                </span>
            </div>
        </div>
    )
}
